import ApplicationsIndex from './DependencyApplicationsIndex'
import ApplicationsSingle from './DependencyApplicationsSingle'
import ApplicationsSingleDependencies from './DependencyApplicationsSingleDependencies'
import ApplicationsSingleVulnerabilities from './DependencyApplicationsSingleVulnerabilities'

export default {
  ApplicationsIndex,
  ApplicationsSingle,
  ApplicationsSingleDependencies,
  ApplicationsSingleVulnerabilities
}
